import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-rod',
    templateUrl: './rod.component.html',
    styleUrls: ['./rod.component.scss'],
    standalone: false
})
export class RodComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
